import {useSyncExternalStore} from 'react'
import {getRelayHostInfo, subscribeRelayRegistry} from '@github-ui/ahp-relay/relay-registry'
import type {RelayHostInfo} from '@github-ui/ahp-relay/relay-connection-runtime'

/**
 * Reads the host/environment info the active relay learned on the AHP handshake
 * for `taskId`. Read-only: it never acquires a relay, so it returns `undefined`
 * until some other consumer (e.g. the session timeline) has one connected.
 */
export function useRelayHostInfo(taskId: string | undefined): RelayHostInfo | undefined {
  return useSyncExternalStore(
    subscribeRelayRegistry,
    () => getRelayHostInfo(taskId),
    () => undefined,
  )
}
